var map = {
	"./1_0_1.jpg": "c071",
	"./1_1_1.jpg": "cf2c",
	"./1_1_2.jpg": "588d",
	"./1_1_3.jpg": "88ae",
	"./1_1_4.jpg": "00c0",
	"./2_1_1.jpg": "d418",
	"./2_1_2.jpg": "2c41",
	"./2_1_3.jpg": "9efc",
	"./2_2_1.jpg": "c76e",
	"./2_2_2.jpg": "86b7",
	"./2_3_1.jpg": "ae49",
	"./2_3_2.jpg": "f5d4",
	"./2_3_3.jpg": "b2be",
	"./2_3_4.jpg": "3260",
	"./2_4_1.jpg": "ee53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afd9";